import type { IconProps } from "./types";

interface PlusIconProps extends IconProps {
  rotate?: string;
}

const PlusIcon = ({
  noPointer,
  width,
  size,
  height,
  style,
  color,
  rotate,
  title,
  ...props
}: PlusIconProps) => {
  const finalStyle = {
    transform: `rotate(${rotate || 0}deg)`,
    ...style
  };

  return (
    <svg
      {...props}
      style={finalStyle}
      data-no-pointer={noPointer}
      width={width || size || 24}
      height={height || size || 24}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
      fill={color || "var(--color-easil-gray-x-dark)"}
      stroke={color || "var(--color-easil-gray-x-dark)"}
      data-testid="PlusIcon"
    >
      <title>{title}</title>
      <g stroke="none" fillRule="evenodd">
        <rect width="2" height="20" x="9" rx="1" />
        <rect width="20" height="2" y="9" rx="1" />
      </g>
    </svg>
  );
};

export default PlusIcon;
